import PageComponent from '../base/PageComponent';

/**
 * Simple utility that makes sure search tab carry the current search term.
 */
export default class SearchTab extends PageComponent
{
    /**
     * @param  JQuery   element       Element that contains the table.
     * @param  string   searchTerm    Initial Search term.
     */
    constructor(element, searchTerm) {
        super(element);
        this.searchTerm = searchTerm;
    }

    /**
     * Initialise the tab
     */
    init() {
        this.href = this.element.attr('href');
        this.setSearchTerm(this.searchTerm);
        this.element.click(event => {this.click(event)})
    }

    /**
     * Handle click on the search tab. Prevent event if the tab is the active one.
     * @param  JqueryEvent event
     */
    click(event) {
        if (this.element.parent().is('.active')) {
            event.preventDefault();
        }
    }

    /**
     * Set the search term on the tab.
     * @param string q
     */
    setSearchTerm(q) {
        this.element.attr('href', this.href + '?q=' + encodeURIComponent(q));
    }

}
